export default "__VITE_ASSET__D9_X0LrM__"